class CartDiscount extends HTMLElement {
  connectedCallback() {
    this.input = this.querySelector('[js-discount-input]');
    this.error = this.querySelector('[js-discount-error]');

    this.querySelector('[js-discount-apply]').addEventListener('click', () => this.apply());

    this.input.addEventListener('keydown', (event) => {
      if (event.key !== 'Enter') return;
      event.preventDefault();
      this.apply();
    });

    this.querySelectorAll('[js-discount-remove]').forEach((button) => {
      button.addEventListener('click', () => this.update(this.codes.filter((code) => code !== button.value)));
    });
  }

  get codes() {
    return JSON.parse(this.getAttribute('codes'));
  }

  async apply() {
    const code = this.input.value.trim();
    if (!code) return;

    this.error.hidden = true;
    await this.update([...this.codes, code], code);
  }

  async update(codes, newCode) {
    if (this.hasAttribute('aria-busy')) return;
    this.setAttribute('aria-busy', 'true');
    document.documentElement.dispatchEvent(new CustomEvent('theme:loading:start', { bubbles: true }));

    const sections = [];
    document.documentElement.dispatchEvent(
      new CustomEvent('cart:prepare-bundled-sections', { bubbles: true, detail: { sections } })
    );

    try {
      const cart = await this.post({ discount: codes.join(','), sections: sections.join(',') });
      const rejected = newCode && cart.discount_codes.some(
        (discountCode) => discountCode.code.toLowerCase() === newCode.toLowerCase() && !discountCode.applicable
      );

      if (rejected) {
        await this.post({ discount: this.codes.join(',') });
        this.error.hidden = false;
        return;
      }

      document.documentElement.dispatchEvent(
        new CustomEvent('cart:change', { bubbles: true, detail: { baseEvent: 'cart-discount:change', cart } })
      );
    } finally {
      this.removeAttribute('aria-busy');
      document.documentElement.dispatchEvent(new CustomEvent('theme:loading:end', { bubbles: true }));
    }
  }

  async post(body) {
    const response = await fetch(`${Shopify.routes.root}cart/update.js`, {
      method: 'POST',
      headers: { 'Content-Type': 'application/json' },
      body: JSON.stringify(body),
    });

    return response.json();
  }
}

if (!customElements.get('cart-discount')) {
  customElements.define('cart-discount', CartDiscount);
}
